import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { enterKeyByDOM } from './services/Claims-monitor/claimsmonitor.service';
import { ModulesService } from './services/Authetication/menu-permission/modules.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'PilotBird';
  // Removed: isProcessingSSOToken - no longer processing tokens from URL

  constructor(
    private router: Router,
    private modulesService: ModulesService
  ) {}

  ngOnInit(): void {
    // Per Verisk spec: UI should NOT process tokens/user data from URL
    // Backend should set session cookie after OIDC callback
    // Session check is handled by route guards (VeriskAuthGuard, LoginAuthenticationGuardService)
    // Removed handleVeriskSSOToken() - violates Verisk spec (tokens/user data in URL)
  }

  ngAfterViewInit() {
    enterKeyByDOM();
  }

  /**
   * REMOVED: handleVeriskSSOToken()
   * 
   * Per Verisk Partner SSO Integration Guide v1.0.0:
   * - Tokens should NEVER be in browser URL query parameters
   * - User data should NEVER be passed via URL
   * - Backend should set session cookie after OIDC callback
   * - UI should only check for local session (localStorage/cookies)
   * 
   * If backend is currently sending loginData in URL, this is a SECURITY VIOLATION.
   * Backend must be updated to set session cookie instead.
   */
  // private handleVeriskSSOToken(): void {
  //   REMOVED: Token/user data extraction from URL
  //   This violates Verisk SSO spec - tokens should never be in URL
  // }

  /**
   * REMOVED: storeSSOLoginData()
   * 
   * Per Verisk spec: User data should come from backend session cookie,
   * not from URL query parameters.
   */
  // private storeSSOLoginData(loginResponse: any): void {
  //   REMOVED: All token/user data processing from URL
  //   Backend must set session cookie instead
  // }

  // REMOVED: cleanURL() and redirectToLogin() methods
  // No longer needed since we don't process URL parameters
}
